import {
  Alert,
  Typography,
  Paper,
  Link,
  IconButton,
  Collapse,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

interface TermsAndConditionsBannerProps {
  open: boolean
  onAgree: () => void
  inline?: boolean
}

export default function TermsAndConditionsBanner({
  open,
  onAgree,
  inline = false,
}: TermsAndConditionsBannerProps) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Collapse in={open}>
      <Paper
        elevation={inline ? 0 : 3}
        sx={{
          ...(!inline && {
            position: 'fixed',
            bottom: isMobile ? '100px' : 0,
            left: 0,
            right: 0,
            zIndex: 1300,
          }),
          borderRadius: 0,
          borderTop: '1px solid #e0e0e0',
          width: isMobile ? '70vw' : '80vw',
        }}
      >
        <Alert
          severity="info"
          role="note"
          aria-label="Terms and conditions"
          sx={{
            borderRadius: 0,
            '& .MuiAlert-message': {
              width: '100%',
            },
          }}
          action={
            <IconButton
              onClick={onAgree}
              size="small"
              sx={{ color: 'inherit' }}
              aria-label="close and accept terms and conditions"
            >
              <CloseIcon />
            </IconButton>
          }
        >
          <Typography variant="body2" sx={{ mb: 2 }}>
            By using FundSorter, you acknowledge that you have read, understood,
            and agree to be bound by our{' '}
            <Link
              href="https://www.fundsorter.com/terms-and-conditions"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: 'inherit' }}
            >
              Terms and Conditions
            </Link>{' '}
            <br />
            If you have any questions, please contact{' '}
            <Link href="mailto:help@fundsorter.com" sx={{ color: 'inherit' }}>
              help@fundsorter.com
            </Link>
          </Typography>
        </Alert>
      </Paper>
    </Collapse>
  )
}
